<template>
    <ul :class="isHeating ? 'temperatureBox heating' : 'temperatureBox'">
        <li>
            <p class="blue">{{ name }}</p>
            <p :class="Number(heatingState) === 1 ? 'orange' : ''">
                {{ Number(heatingState) === 1 ? "加热中" : "未加热" }}
            </p>
        </li>
        <li>
            <p>选择/停止：</p>
            <p :class="Number(choose) === 0 ? 'red' : ''">{{ Number(choose) === 1 ? "选择" : "停止" }}</p>
        </li>
        <li>
            <p>启/停：</p>
            <p :class="Number(startStop) === 0 ? 'red' : ''">{{ Number(startStop) === 1 ? "启动" : "停止" }}</p>
        </li>
        <li>
            <p>设定温度：</p>
            <p>{{ setTemp }}℃</p>
        </li>
        <li>
            <p>实测温度：</p>
            <p :class="Number(currentTemp) > 0 ? 'heating-alone' : ''">{{ currentTemp }}℃</p>
        </li>
    </ul>
</template>

<script>
export default {
    name: "TempEF",
    props: {
        name: {
            type: String
        },
        choose: {
            type: [String, Number]
        },
        startStop: {
            type: [String, Number]
        },
        heatingState: {
            type: [String, Number]
        },
        setTemp: {
            type: [String, Number],
            default: 0
        },
        currentTemp: {
            type: [String, Number],
            default: 0
        }
    },
    emits: [],
    computed: {
        isHeating() {
            return Number(this.heatingState) === 1;
        }
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {}
};
</script>

<style lang="scss" scoped>
ul {
    li {
        margin-bottom: 10px !important;
        &:last-child {
            margin-bottom: 0 !important;
        }
        p {
            font-size: 14px !important;
            color: #fff !important;
        }

        .blue {
            color: #2a82e4 !important;
        }

        .orange {
            color: #fa8052 !important;
        }

        .red {
            color: #e25453 !important;
        }
    }
}
</style>
